window.StandardCart = (function () {

    var betDeletionModeMap = {
        DeleteOutcomes: 'DeleteOutcomes',
        NoDeleteOutComes: 'NoDeleteOutComes',
        NoDeleteOutComesWithMaxBet: 'NoDeleteOutComesWithMaxBet'
    };

    const MAX_CART_SIZE = 50;
    var items = {},
        dom = {},
        type = 'Single', // Single || Express || System
        state = 'Empty', // Empty || HasItems || Success
        activeCoefMode = 'Fix', // Fix || NotLess || Any
        currency = window.globalAppSettings.currentUser.defaultBalance.currencyCode,
        betSum = 0,
        minMoneyValue = 20,
        betDeletionMode = betDeletionModeMap.DeleteOutcomes,
        betSumCombobox,
        bonusExpressAmountValue = 0,
        isBettingCartDOMReady = false;
    var typesMap = {
        single: 'single',
        express: 'express',
        system: 'system'
    };


    var getUnique = function (value, index, self) {
        return self.indexOf(value) === index;
    };
    var getDuplicates = function (value, index, self) {
        return self.indexOf(value) !== index
    };

    document.addEventListener('bettingCartIsLoaded', () => {
        isBettingCartDOMReady = true;
        document.dispatchEvent(new CustomEvent('cartIsReadyToAddOutcomes'));
    });

    var load = function (data) {
        dom = {
            betSumInput: $('#standard-cart__bet-sum-input'),
            betSumInputWrapper: $('#standard-cart__bet-sum-input-wrapper'),
            maxBetSumMoneyValueBtn: $('#standard-cart__bet-sum-max-money-value-btn'),
            possibleMoneyValue: $('[js-node="standard-cart__possible-money-value"]'),
            calcBetSumSingle: $('[js-node="standard-cart__bet-sum-single-value"]'),
            calcBetSumSingleBonus: $('[js-node="cart__bonus-bet-sum-value"]'),
            bonusBetSumContainer: $('[js-node="cart__bonus-bet-sum-container"]'),
            commonCoef: $('[js-node="standard-cart__common-coef"]'),
            coefModeMenuItemCommon: $('[js-node="standard-cart__coef-mode-menu-item-common"]'),
            container: $('[js-node="standard-cart"]'),
            notWinEventsCount: $('[js-node="standard-cart__not-win-events-count"]'),
            items: $('[js-node="standard-cart__items"]'),
            itemsCount: $('[js-node="betting-cart__items-count"]'),
            menuItems: $('[js-node="standard-cart__menu-item"]'),
            optionCount: $('[js-node="standard-cart__option-count"]'),
            removeAllItemsBtn: $('[js-node="betting-cart__remove-all-btn"]'),
            betDeletionMode: $('[js-node="cart-settigns__remove-coefs-after-send"]'),
            sendBtn: $('[js-node="standard-cart__send-btn"]'),
            acceptBtn: $('[js-node="standard-cart__accept-btn"]'),
            errorsIcon: $('[js-node="standard-cart__errors"]'),
            successBtn: $('#cart__success-close'),
            betSumCurrency: $('[js-node="cart__currency-select"]'),
            bonusExpressContainer: $('#cart-bonus-express-container'),
            bonusExpressInput: $('#cart__bonus-express-input'),
            bonusExpressAmountContainer: $('#cart__bonus-express-amount-container'),
            bonusExpressAmountValue: $('#cart__bonus-express-amount-value'),
            bonusExpressAmountTooltip: $('#cart__bonus-express-amount-tooltip')
        };

        if (data) {
            if (data.hasOwnProperty('items')) {
                for (key in data['items']) {
                    addItem(data['items'][key]);
                }

                fetchCartItems(true);
            }

            if (data.hasOwnProperty('type'))
                type = data['type'];

            if (data.hasOwnProperty('betSum'))
                betSum = data['betSum'];

            if (data.hasOwnProperty('currency'))
                currency = data['currency'];

            if (data.hasOwnProperty('isBonusExpress')) {
                if (data.isBonusExpress === true) {
                    bonusExpress.enable();
                } else {
                    bonusExpress.disable();
                }
            }

            if (data.hasOwnProperty('freebet')) {
                if (data.freebet.isActive) {
                    $(document).trigger('notification_SetFreebet', {
                        number: data.freebet.id,
                        title: data.freebet.title,
                        sum: data.freebet.sum,
                        isSelected: data.freebet.isSelected
                    });
                }
            }
        }

        betDeletionMode = betDeletionModeMap[window.globalAppSettings.betDeletionMode] || betDeletionModeMap.DeleteOutcomes;
        activeCoefMode = window.globalAppSettings.bettingCartSubMode;

        dom.coefModeMenuItemCommon.filter('[value="' + activeCoefMode + '"]').prop('checked', true);

        updateCount();
        setType(type);
        setBetDeletionMode(betDeletionMode);
        setCurrency(currency);

        if (parseInt(betSum) !== 0)
            dom.betSumInput.val(app.numberToString(betSum));


        var maxBetButtonSettings = globalAppSettings.currentUser.bettingCart['max-bet-amount-button'];

        if (!!!maxBetButtonSettings.IsEnabled) {
            setBetSumMaxMoneyValueButtonIsDisabled(true, maxBetButtonSettings.Message);
        }

        var commonSendButtonSettings = globalAppSettings.currentUser.bettingCart['common-send-button'];
        if (!!commonSendButtonSettings.IsEnabled) {
            dom.sendBtn.removeClass('m-blocked');
        }
        else {
            dom.sendBtn.addClass('m-blocked');
            dom.sendBtn.removeClass('disabled');
        }

        if (!!commonSendButtonSettings.Tooltip) {
            dom.sendBtn.attr('bb-tool', commonSendButtonSettings.Tooltip);
        }
        else {
            dom.sendBtn.removeAttr('bb-tool');
        }


        if ($.fn.niceSelect) {
            dom.betSumCurrency.niceSelect();
            dom.notWinEventsCount.niceSelect();
        }

        bindUI();
        startFetch();
        initCombobox();
    };

    var fetchCartItems = function (includePrematch) {
        if (!isFetchReady)
            return;

        includePrematch = includePrematch || false;
        var coefs = (includePrematch) ? getCoefs() : getLiveCoefs();
        if (coefs.length == 0)
            return;

        isFetchReady = false;
        Ajax.postJson("/BettingCart/GetActualCoefs", {
            data: {
                coefs: coefs
            },
            success: function (resp) {
                if (Array.isArray(resp)) {

                    var hasChanges = false;
                    for (var i = 0; i < resp.length; i++) {
                        var actual = resp[i];
                        var item = getItem(actual.oid);

                        if (item) {
                            var updateResult = item.updateCoef({
                                actualId: actual.aid,
                                value: actual.val,
                                isActive: actual.act,
                                isLive: actual.il,
                                eventIsActive: actual.ea,
                                eventIsOver: actual.eo,
                                eventId: actual.ei,
                                rTitle: actual.n,
                                homeTeam: actual.ht,
                                awayTeam: actual.at
                            });
                            hasChanges = hasChanges || updateResult;
                            if (updateResult) {
                                item.updateExternalCoef(actual.oid, actual.aid, actual.val, actual.act);
                            }
                        }
                    }

                    if (hasChanges) {
                        BettingCart.calc();
                        BettingCart.validate();
                        BettingCart.save();
                    }
                }
                isFetchReady = true;
            },
            error: function () {
                isFetchReady = true;
            }
        });
    };

    var isFetchReady = true;
    var fetchInterval;
    var startFetch = function () {
        var interval = (globalAppSettings.currentUser.isAnonymous) ? 30 * 1000 : 4 * 1000;
        clearInterval(fetchInterval);
        fetchInterval = setInterval(fetchCartItems, interval);
    };

    var initCombobox = function () {
        var sums = window.globalAppSettings.additionalSumValues;

        if (window.globalAppSettings.additionalSum && sums.length > 0) {
            var cValues = [];

            for (var i = 0; i < sums.length; i++) {
                if (sums[i] > 0) {
                    cValues.push(sums[i]);
                }
            }

            if (cValues.length > 0) {
                betSumCombobox = new Combobox(cValues, dom.betSumInput);
            }
        }
    };

    var getData = function () {
        var data = {
            items: [],
            type: type,
            state: state,
            activeCoefMode: activeCoefMode,
            betSum: betSum,
            currency: currency,
            isBonusExpress: bonusExpress.isEnabled,
            freebet: {
                id: Freebet.getFreebetId(),
                isActive: Freebet.isActive(),
                isSelected: Freebet.isSelected(),
                title: Freebet.getTitle(),
                sum: Freebet.getSum()
            }
        };

        for (key in items) {
            data.items.push({
                'aId': items[key].actualId,
                'val': items[key].coefValue,
                'eId': items[key].eventId,
                'eTitle': items[key].eventTitle,
                'oId': items[key].originalId,
                'rTitle': items[key].resultTitle,
                'bet': items[key].bet,
                'isLive': items[key].isLive,
                'isSelected': items[key].isSelected,
                'currency': items[key].currency,

                'isActive': items[key].coefIsActive,
                'isOver': items[key].coefIsOver,
                'eventIsActive': items[key].eventIsActive,
                'eventIsOver': items[key].eventIsOver
            });
        }

        return data;
    };

    var autoSwitchType = function (isAdd) {
        var count = Object.values(items).filter(function (item) {
            return !item.eventIsOver && !item.coefIsOver;
        }).length;

        switch (getType().toLowerCase()) {
            case typesMap.single:
                if (count === 2 && isAdd)
                    setType('Express');
                break;
            case typesMap.express:
                if (count <= 1 && !isAdd)
                    setType('Single');
                break;
            case typesMap.system:
                if (count == 2 && !isAdd)
                    setType('Express');
                else if (count <= 1 && !isAdd)
                    setType('Single');
                break;
            default:
                break;
        }
    };

    var addItem = function (data) {
        if (isBettingCartDOMReady) {
            if (data.hasOwnProperty('oId') === false) {
                return false;
            }
               
            if (getItem(data.oId) !== null) {
                //TODO: Check coef actuality.
                return true;
            }

            if (quantity() >= MAX_CART_SIZE) {
                return false;
            }

            items[data.oId] = new app.StandardCartItem(data);

            if (BettingCart.getIsLoading() === false) {
                if (window.globalAppSettings.defaultBet === true && window.globalAppSettings.defaultBetSum > 0) {
                    items[data.oId].bet = window.globalAppSettings.defaultBetSum;

                    if (!dom.betSumInput.val()) {
                        var defaultBetSum = currency === BettingCart.currencyMap.CURRENCY ? window.globalAppSettings.defaultBetSum : window.globalAppSettings.defaultBetSum * window.globalAppSettings.bonusExchangeRate;
                        dom.betSumInput.val(app.numberToString(defaultBetSum));
                        betSum = defaultBetSum;
                    }
                }

                if (data.hasOwnProperty('loadActualCoefValue')) {
                    if (data.loadActualCoefValue) {
                        items[data.oId].loadActualCoefValue();
                    }
                }
            }

            items[data.oId].draw();
            items[data.oId].checkActive();


            updateCount();
            autoSwitchType(true);
            BettingCart.calc();
            if (BettingCart.validate()) {
                StandardCart.serverValidate();
            }

            $(document).trigger('notificationCoefIsAddedToCart', {
                outcomeId: parseInt(data.oId)
            });

            document.dispatchEvent(new CustomEvent('notificationCoefIsAddedToCartVue', {
                detail: parseInt(data.oId)
            }));

            return true;
        };

        return new Promise((resolve) => {
            document.addEventListener('cartIsReadyToAddOutcomes', () => {
                return resolve(data)
            })
        }).then((data) => addItem(data));

    };

    var removeItemAfterSend = function (originalId) {
        if (items.hasOwnProperty(originalId)) {
            items[originalId].erase();
            items[originalId] = null;
            delete items[originalId];

            BettingCart.Highlighting.deactivate.allScopes(originalId);

            updateCount();
            autoSwitchType(false);

            if (quantity() < 1) {
                betSum = 0;
                dom.betSumInput.val('');
            }

            $(document).trigger('notificationCoefIsRemovedFromCart', {
                outcomeId: parseInt(originalId)
            });

            document.dispatchEvent(new CustomEvent('notificationCoefIsRemovedFromCartVue', {
                detail: parseInt(originalId)
            }));

            BettingCart.calc();
        }
    };

    var removeItemWithoutValidation = function (originalId) {
        if (items.hasOwnProperty(originalId)) {
            items[originalId].erase();
            items[originalId] = null;
            delete items[originalId];

            BettingCart.Highlighting.deactivate.allScopes(originalId);

            updateCount();
            autoSwitchType(false);

            if (quantity() < 1) {
                betSum = 0;
                dom.betSumInput.val('');
            }

            $(document).trigger('notificationCoefIsRemovedFromCart', {
                outcomeId: parseInt(originalId)
            });

            document.dispatchEvent(new CustomEvent('notificationCoefIsRemovedFromCartVue', {
                detail: parseInt(originalId)
            }));

            BettingCart.calc();
        }
    };

    var removeItem = function (originalId) {
        removeItemWithoutValidation(originalId);
        if (BettingCart.validate()) {
            StandardCart.serverValidate();
        }

        $(document).trigger('notificationCoefIsRemovedFromCart', {
            outcomeId: parseInt(originalId)
        });

        document.dispatchEvent(new CustomEvent('notificationCoefIsRemovedFromCartVue', {
            detail: parseInt(originalId)
        }));
    };

    var removeAllItems = function (options) {
        options = options ? options : {};
        options.removeSelected = options.removeSelected === true ? true : false;
        options.coefsToRemove = options.coefsToRemove ? options.coefsToRemove : Object.keys(items).map(function (key) { return parseInt(key); });

        for (var oId in items) {
            if (options.removeSelected === true && items[oId].isSelected === false) {
                continue;
            }

            if (options.coefsToRemove.indexOf(parseInt(oId)) !== -1) {
                items[oId].erase();
                items[oId] = null;
                delete items[oId];

                $(document).trigger('notificationCoefIsRemovedFromCart', {
                    outcomeId: parseInt(oId)
                });

                document.dispatchEvent(new CustomEvent('notificationCoefIsRemovedFromCartVue', {
                    detail: parseInt(oId)
                }));

                BettingCart.Highlighting.deactivate.allScopes(oId);
            }
        }
        updateCount();

        setDefaultBetSumAndCurrency();

        BettingCart.calc();
        BettingCart.validate();
    };

    var removeAllItemsAfterSend = function (coefsToRemove) {
        removeAllItems({
            coefsToRemove: coefsToRemove,
            removeSelected: true
        });
    };

    var getItem = function (id) {
        if (items.hasOwnProperty(id))
            return items[id];
        else
            return null;
    };

    var getItems = function () {
        return items;
    };

    var getLiveCoefs = function () {
        return Object.values(items).filter(function (item) { return !!item.isLive; }).map(function (i) {
            return {
                coefid: i.actualId,
                eventid: i.eventId
            }
        });
    };

    var getCoefs = function () {
        return Object.values(items).map(function (i) {
            return {
                coefid: i.actualId,
                eventid: i.eventId
            }
        });
    };

    var getSelectedItemForFreebet = function () {
        var freebetSelectedItemId = Freebet.getSelectedItemId();
        var selectedForFreebet = Object.values(items).filter(function (item) {
            return parseInt(item.originalId) === freebetSelectedItemId;
        });

        if (selectedForFreebet.length > 0) {
            return selectedForFreebet[0];
        }

        return null;
    }

    var getSingleSelectedItemForFreebetProposal = function () {
        var selectedItems = Object.values(items).filter(function (item) {
            return item.isSelected;
        });

        if (selectedItems.length !== 1)
            return undefined;

        return selectedItems[0];
    }

    var getCurrency = function () {
        return currency;
    }

    var setCurrency = function (val) {
        currency = val;
        dom.betSumCurrency.val(val);
    }

    var quantity = function (onlySelected) {
        onlySelected = onlySelected || false;
        var quantity = 0;

        if (onlySelected === true) {
            for (key in items) {
                if (items[key].isSelected === true) {
                    quantity += 1;
                }
            }
        } else {
            quantity = Object.keys(items).length;
        }

        return quantity;
    }

    var hasItem = function (oid) {
        return items.hasOwnProperty(oid);
    };

    var updateCount = function () {
        var cnt = Object.keys(items).length;

        dom.itemsCount.html(cnt);

        if (cnt > 0) {
            dom.itemsCount.show();
            updateState('HasItems');
        } else {
            dom.itemsCount.hide();
            updateState('Empty');
        }
    };

    var setType = function (newType) {
        type = newType;

        dom.menuItems.removeClass('active');

        dom.container
            .removeClass('single express system')
            .addClass(type.toLowerCase());

        dom.menuItems.filter('[data-type="' + type + '"]').addClass('active');

        BettingCart.calc();
        if (BettingCart.validate()) {
            StandardCart.serverValidate();
        }

        $(document).trigger('notificationCartTypeIsChanged', {
            newType: newType
        });
    };

    var getType = function () {
        return type;
    };

    var isTypeSingle = function () {
        return type.toLowerCase() === typesMap.single;
    }

    var updateState = function (state) {
        state = state.toLowerCase() || '';

        hideSuccessMessage();

        dom.container
            .removeClass('hasitems')
            .removeClass('empty')
            .addClass(state);

        if (state === 'empty')
            dom.removeAllItemsBtn.hide();
        else
            dom.removeAllItemsBtn.show();
    };

    //центровка сообщения на экране при большом кол-ве ставок
    function heightCorrection() {
        if ($('.cart__body').height() > $('#layout-right-column').height()) {
            $('#success-center-message').addClass('m-sticky');
        } else if (globalAppSettings.isMobileDevice) {
            $('#success-center-message').addClass('m-sticky');
        } else {
            $('#success-center-message').removeClass('m-sticky');
        };
    };

    var showSuccessMessage = function (needConfirmation) {
        dom.container.addClass('success');
        heightCorrection();
        if (needConfirmation)
            dom.container.addClass('m-need-confirmation');
    };

    var hideSuccessMessage = function () {
        dom.container.removeClass('success');
        dom.container.removeClass('m-need-confirmation');
    };

    var setCoefMode = function (newActiveCoefMode) {
        activeCoefMode = newActiveCoefMode;

        dom.coefModeMenuItemCommon.filter('[value="' + activeCoefMode + '"]').prop('checked', true);

        BettingCart.save();
    };

    var setBetDeletionMode = function (newVal) {
        if (betDeletionModeMap[newVal]) {
            dom.betDeletionMode.filter('[value="' + betDeletionModeMap[newVal] + '"]').prop('checked', true);
        } else {
            dom.betDeletionMode.filter('[value="' + betDeletionModeMap.DeleteOutcomes + '"]').prop('checked', true);
        }
    };

    var setBetSum = function (newBetSum) {
        betSum = (newBetSum) ? parseInt(newBetSum) : 0;

        BettingCart.calc();
        BettingCart.validate();
    };

    var setDefaultBetSumAndCurrency = function () {
        setCurrency(BettingCart.currencyMap.CURRENCY)
        dom.betSumCurrency.niceSelect('update');

        dom.betSumInput.val(app.numberToString(window.globalAppSettings.defaultBetSum));
        betSum = window.globalAppSettings.defaultBetSum;
    }

    var getNotWinEventsCount = function () {
        return dom.notWinEventsCount.val() || 1;
    };

    var getBetSum = function () {
        return betSum;
    };

    var getActiveCoefMode = function () {
        return activeCoefMode;
    };

    var getBetDeletionMode = function () {
        return betDeletionMode;
    };

    var updateCalcResults = function (results) {
        switch (type.toLowerCase()) {
            case 'single':
                if (results.hasOwnProperty('PossibleMoneyValue'))
                    dom.possibleMoneyValue.html(app.numberToString(results.PossibleMoneyValue));

                if (results.hasOwnProperty('betSum'))
                    dom.calcBetSumSingle.html(app.numberToString(results.betSum));

                if (results.hasOwnProperty('betSumBonus') && results.betSumBonus != 0) {
                    dom.calcBetSumSingleBonus.html(app.numberToString(results.betSumBonus));
                    dom.bonusBetSumContainer.removeClass('m-hidden');
                } else {
                    dom.bonusBetSumContainer.addClass('m-hidden');
                }

                break;
            case 'express':
                if (results.hasOwnProperty('PossibleMoneyValue'))
                    dom.possibleMoneyValue.html(app.numberToString(results.PossibleMoneyValue));

                if (results.hasOwnProperty('coef'))
                    dom.commonCoef.html(window.Utils.displayCoefValue(results.coef));

                if (results.hasOwnProperty('bonusExpressAmountValue')) {
                    bonusExpressAmountValue = results.bonusExpressAmountValue;
                    dom.bonusExpressAmountValue.html(results.bonusExpressAmountValue);
                }

                break;
            case 'system':
                if (results.hasOwnProperty('PossibleMoneyValue'))
                    dom.possibleMoneyValue.html(app.numberToString(results.PossibleMoneyValue));

                if (results.hasOwnProperty('OptionCount')) {
                    dom.optionCount.html(results.OptionCount);
                    if ($.fn.niceSelect) {
                        dom.notWinEventsCount.niceSelect('update');
                    }
                }

                //if (isBonus === true)
                //dom.bonusSumValue.html(app.numberToString(betSum * 1000));

                break;
            default:
                break;
        }
    };

    var validate = function () {
        var result = true,
            type = getType(),
            // добавлено в корзину и отмечено галочкой (активные кэфы)
            selectedItemsCnt = 0,
            selectedItems = items,
            errors = [];

        if (Freebet.isSelected() && isTypeSingle()) {
            selectedItems = {};
            var selectedItemForFreebet = getSelectedItemForFreebet();

            if (selectedItemForFreebet) {
                selectedItems[selectedItemForFreebet.originalId] = selectedItemForFreebet;
                selectedItemsCnt = 1;
            }
        } else {
            for (key in selectedItems) {
                if (selectedItems[key].isSelected) {
                    ++selectedItemsCnt;
                }
            }
        }

        const errorsMsgs = {
            subModeConflictMessage: Localization.getString('BettingCart.SubModeError', 'Коэффициент был изменен. Для заключения пари примите изменения.'),
            combinatonErrorMessage: Localization.getString('BettingCart.CombinationError', 'Вы не можете комбинировать результаты одного события.'),
            tempCoefBlockErrorMessage: Localization.getString('BettingCart.TempBlockError', 'Прием пари на событие временно приостановлен.'),
            systemLiveErrorMessage: Localization.getString('BettingCart.SystemLiveError', 'Все экспрессы(система) не может содержать Live-события.'),
            countErrorMessage0: Localization.getString('BettingCart.CountError0', 'Не выбран ни один результат.'),
            countErrorMessage3: Localization.getString('BettingCart.CountError3', 'Количество событий для пари типа Все экспрессы (система) не может быть меньше трех.'),
            countErrorMessage16: Localization.getString('BettingCart.CountError16', 'Количество событий в системе не может быть больше 16-ти.'),
            countErrorMessage2: Localization.getString('BettingCart.CountError2', 'Количество событий в экспрессе не может быть меньше двух.'),
            badBetSumMessage: Localization.getString('BettingCart.BetSumError', 'Пожалуйста, укажите сумму ставки.'),
        };

        if (selectedItemsCnt === 0) {
            errors = [errorsMsgs.countErrorMessage0];
        } else {
            itemsErrorsCnt = validateItems(selectedItems, type, errorsMsgs);

            switch (type) {
                case 'Express':
                    errors = validateExpress(selectedItemsCnt, errorsMsgs);
                    break;
                case 'System':
                    errors = validateSystem(selectedItemsCnt, errorsMsgs);
                    break
                default:
                    break;
            }
        }

        if (errors.length > 0 || itemsErrorsCnt > 0) {
            showErrors(errors);
            result = false;
        } else {
            hideErrors();
        }

        bonusExpress.checkIfIsAvailable();

        setSendButtonState(result);

        return result;
    };

    var validateItems = function (items, type, errorsMsgs) {
        var errorsCnt = 0,
            errorsFixNotLessCnt = 0,
            item,
            itemErrorsCnt,
            selectedItems = {};

        for (key in items) {
            if (items[key].isSelected === true) {
                selectedItems[key] = items[key];
            } else {
                items[key].errors = [];
                items[key].hideErrors();
            }
        }

        var duplicateEventIds = Object.keys(selectedItems).map(function (key) {
            return selectedItems[key].eventId;
        }).filter(getDuplicates).filter(getUnique);

        for (key in selectedItems) {
            item = selectedItems[key];
            item.errors = [];
            itemErrorsCnt = 0;

            if (item.isSelected === true) {

                switch (activeCoefMode) {
                    case 'Fix':
                        if (parseFloat(item.originalCoefValue) !== parseFloat(item.coefValue)) {
                            items[key].errors.push(errorsMsgs.subModeConflictMessage);
                            ++errorsCnt;
                            ++itemErrorsCnt;
                            ++errorsFixNotLessCnt;

                            acceptButtonState(true);
                        }
                        break;
                    case 'NotLess':
                        if (parseFloat(item.originalCoefValue) > parseFloat(item.coefValue)) {
                            items[key].errors.push(errorsMsgs.subModeConflictMessage);
                            ++errorsCnt;
                            ++errorsFixNotLessCnt;
                            ++itemErrorsCnt;

                            acceptButtonState(true);
                        }
                        break;
                    case 'Any':
                    default:
                        break;
                }

                if (type === 'Express' || type === 'System') {
                    if (duplicateEventIds.indexOf(item.eventId) !== -1) {
                        item.errors.push(errorsMsgs.combinatonErrorMessage);
                        ++errorsCnt;
                        ++itemErrorsCnt;
                    }
                } else if (type === 'Single') {
                    if (item.bet === '' || item.bet <= 0) {
                        item.errors.push(errorsMsgs.badBetSumMessage);
                        ++errorsCnt;
                        ++itemErrorsCnt;
                    }

                    //if (item.bet < minMoneyValue) {
                    //    item.errors.push("Минимальная сумма пари - " + minMoneyValue + " руб.");
                    //    ++errorsCnt;
                    //    ++itemErrorsCnt;
                    //}
                }

                if (type === 'System') {
                    if (item.isLive) {
                        item.errors.push(errorsMsgs.systemLiveErrorMessage);
                        ++errorsCnt;
                        ++itemErrorsCnt;
                    }
                }

                if (itemErrorsCnt > 0) {
                    item.showErrors();
                } else {
                    item.hideErrors();
                }
            } else {
                item.hideErrors();
            }
        }

        if (errorsFixNotLessCnt === 0) {
            acceptButtonState(false);
        }

        return errorsCnt;
    };

    var validateExpress = function (itemsCnt, errorsMsgs) {
        var errors = [];

        if (itemsCnt < 2) {
            errors.push(errorsMsgs.countErrorMessage2);
        }

        if (Freebet.isSelected() && Freebet.isActive())
            return errors;

        if (betSum === '' || betSum <= 0) {
            errors.push(errorsMsgs.badBetSumMessage);
            dom.betSumInputWrapper.addClass('m-error');
        } else {
            dom.betSumInputWrapper.removeClass('m-error');
        }
        //if (betSum < minMoneyValue) {
        //    errors.push("Минимальная сумма пари - " + minMoneyValue + " руб.");
        //}

        return errors;
    };

    var validateSystem = function (itemsCnt, errorsMsgs) {
        var errors = [];

        if (itemsCnt < 3) {
            errors.push(errorsMsgs.countErrorMessage3);
            $('[js-node="cart__not-win-events-count-wrapper"]').addClass('m-empty');
        } else if (itemsCnt > 16) {
            errors.push(errorsMsgs.countErrorMessage16);
        } else {
            $('[js-node="cart__not-win-events-count-wrapper"]').removeClass('m-empty');
        }

        if (Freebet.isSelected() && Freebet.isActive())
            return errors;

        if (betSum === '' || betSum <= 0) {
            errors.push(errorsMsgs.badBetSumMessage);
            dom.betSumInputWrapper.addClass('m-error');
        } else {
            dom.betSumInputWrapper.removeClass('m-error');
        }


        var minMoneyValue = optsCount * 5 > window.globalAppSettings.minBetAmount ? optsCount * 5 : window.globalAppSettings.minBetAmount;
        if (errors.length < 1) {
            var optsCount = Number($(dom.optionCount).text());
            if (!isNaN(optsCount)) {
                switch (currency) {
                    case BettingCart.currencyMap.BONUS: {
                        minMoneyValue = minMoneyValue * globalAppSettings.bonusExchangeRate;
                        if (betSum < minMoneyValue) {
                            errors.push(window.Localization.getString('BettingCart.MinAmount', 'Минимальная сумма ставки составляет ') + app.numberToString(minMoneyValue) + Utils.svgHtml('bonus', 'currency-bonus currency-bonus--tooltip'));
                        }
                        break;
                    }
                    case BettingCart.currencyMap.CURRENCY: {
                        minMoneyValue = minMoneyValue;
                        if (betSum < minMoneyValue) {
                            //TODO быстрофикс
                            var currencyText = window.globalAppSettings.currentUser.defaultBalance.currencyCode == 'RUB'
                                ? 'руб.'
                                : window.globalAppSettings.currentUser.defaultBalance.currencyCode;
                            errors.push(window.Localization.getString('BettingCart.MinAmount', 'Минимальная сумма ставки составляет ') + app.numberToString(minMoneyValue) + ' ' + currencyText);
                        }
                        break;
                    }
                    default: {
                        errors.push(window.Localization.getString('BettingCart.CurrencyError', 'Не выбрана валюта ставки.'));
                        break;
                    }
                }
            }
        }
        return errors;
    };

    var setSendButtonState = function (newState) {
        if (newState === true) {
            dom.sendBtn.removeClass('disabled');
        } else if (!dom.sendBtn.hasClass('m-blocked')) {

            dom.sendBtn.addClass('disabled');
        }
    };

    var showErrors = function (errors) {
        if (typeof (errors) == 'string') errors = [errors];
        var text = '',
            errorsLength = errors.length;

        hideErrors();

        if (errorsLength > 0) {
            for (var i = 0; i < errorsLength; i++) {
                text += errors[i];

                if (i != errorsLength - 1)
                    text += '<br />';
            }

            dom.errorsIcon
                .attr('bb-tool', text)
                .show();
        }
    };

    var hideErrors = function () {
        dom.errorsIcon
            .attr('bb-tool', '')
            .hide();
    };

    var acceptButtonState = function (newState) {
        if (newState === true) {
            dom.acceptBtn.removeClass('disabled');
        } else {
            dom.acceptBtn.addClass('disabled');
        }
    };

    var updateBonusTooltip = function () {
        if (currency === BettingCart.currencyMap.BONUS && betSum > 0) {
            dom.betSumInput.attr('bb-tool', (betSum / 1000) + ' ' + window.globalAppSettings.currentUser.defaultBalance.currencySymbol);
        } else {
            dom.betSumInput.removeAttr('bb-tool');
        }
    };

    // accept btn click handler
    var syncCoefs = function () {
        for (key in items) {
            items[key].originalCoefValue = items[key].coefValue;
        }

        acceptButtonState(false);

        BettingCart.save();
        BettingCart.validate();
    };

    var MIN_EXPRESS_COMMON_COEF = 1.6;
    var bonusExpress = {
        validate: function () {
            var sumDiff = window.globalAppSettings.currentUser.bonuses - bonusExpressAmountValue;
            var expressCommonCoef = StandardCartCalc.getExpressCommonCoef();
            if (quantity(true) > 2 && type.toLowerCase() === typesMap.express && currency !== BettingCart.currencyMap.BONUS && sumDiff >= 0 && expressCommonCoef >= MIN_EXPRESS_COMMON_COEF) {
                dom.bonusExpressAmountTooltip.removeAttr('bb-tool');
                return true;
            } else {
                if (sumDiff < 0) {
                    dom.bonusExpressAmountTooltip.attr('bb-tool', Localization.getString('BettingCart.BEActivationMessage1', 'Для активации бонусного экспресса Вам надо накопить еще ') + app.numberToString(Math.abs(sumDiff)) + Localization.getString('BettingCart.BEActivationMessage2', ' баллов'));
                } else {
                    dom.bonusExpressAmountTooltip.removeAttr('bb-tool');
                }
            }

            return false;
        },
        checkIfIsAvailable: function () {
            if (this.validate()) {
                dom.bonusExpressContainer.removeClass('m-disabled');
                return true;
            } else {
                dom.bonusExpressContainer.addClass('m-disabled');
                this.disable();
                return false;
            }
        },
        isEnabled: false,
        enable: function () {
            if (this.validate()) {
                this.isEnabled = true;
                dom.bonusExpressAmountContainer.show();
                dom.bonusExpressInput.prop('checked', true);
                BettingCart.calc();
            }
        },
        disable: function () {
            this.isEnabled = false;
            dom.bonusExpressInput.prop('checked', false);
            dom.bonusExpressAmountContainer.hide();
            BettingCart.calc();
        }
    };

    var bindUI = function () {
        $(document).on('coefInBettingCartIsOverChanged', function (e, data) {
            autoSwitchType(!data.isOver);
        });

        dom.acceptBtn.on('click', function () {
            syncCoefs();
        });

        dom.sendBtn.on('click', function () {
            if (!globalAppSettings.currentUser.bettingCart['common-send-button'].IsEnabled)
                return;

            var captchaDiv = $('#recaptcha');

            if (captchaDiv.attr('data-captcharequired') === 'True') {

                if (captchaDiv.is(':empty')) {
                    grecaptcha.render($('#recaptcha')[0], {
                        'callback': function () { BettingCart.sendWithFreebetProposal(); },
                    });
                }

                grecaptcha.execute();

                var res = grecaptcha.getResponse();

                if (res.length != 0) {
                    BettingCart.sendWithFreebetProposal();
                }

            }
            else {
                BettingCart.sendWithFreebetProposal();
            }
        });

        dom.menuItems.on('click', function () {
            var type = $(this).data('type');
            setType(type);
        });

        dom.removeAllItemsBtn.on('click', function () {
            setType('Single');
            removeAllItems();
        });

        dom.coefModeMenuItemCommon.on('click', function () {
            var newVal = $(this).val();

            if (newVal !== activeCoefMode) {
                setCoefMode(newVal);
                Ajax.postJson("/account/profile/edit/bets/changeacceptancemode/submit", {
                    data: {
                        betAcceptanceMode: newVal,
                        isRedirect: false
                    }
                });
            }
        });

        dom.maxBetSumMoneyValueBtn.on('click', function () {
            if (!globalAppSettings.currentUser.bettingCart['max-bet-amount-button'].IsEnabled) return

            loadBetSumMaxMoneyValue();
        });

        dom.betSumCurrency.on('change', function () {
            var val = $(this).val();

            document.dispatchEvent(new CustomEvent('mtmCustomEvent', {
                detail: {
                    id: 'd-i06-e13',
                    value: val,
                },
            })
            );

            if (currency.toLowerCase() !== val.toLowerCase()) {
                setCurrency(val);

                // TODO сделать единый конвертер валют
                if (currency === 'Bonuses') {
                    setBetSum(betSum * window.globalAppSettings.bonusExchangeRate);
                    dom.betSumInput.val(app.numberToString(betSum));
                } else {
                    var newVal = betSum / window.globalAppSettings.bonusExchangeRate;
                    setBetSum(newVal < 1 ? 1 : newVal);
                    dom.betSumInput.val(app.numberToString(betSum));
                }

                BettingCart.calc();
                BettingCart.validate();
            }
        });

        dom.betSumInput.on('input change', function (e) {
            var filteredVal = $(this).val().replace(/\D/g, '');
            $(this).val((parseInt(filteredVal) === 0 || !filteredVal) ? '' : app.numberToString(filteredVal));

            setBetSum(filteredVal);
        });

        dom.notWinEventsCount.on('change', function () {
            BettingCart.calc();
            BettingCart.validate();
            $(document).trigger('notification_notWinEventCountChanged');
        });

        dom.successBtn.on('click', function () {
            hideSuccessMessage();
        });

        dom.betDeletionMode.on('change', function () {
            var newVal = betDeletionModeMap[$(this).val()] || betDeletionModeMap.DeleteOutcomes;

            if (newVal !== getBetDeletionMode) {
                setBetDeletionMode(newVal);
                Ajax.postJson("/account/profile/edit/savebetdeletionmode", {
                    data: {
                        selectedMode: newVal,
                        isRedirect: false
                    }
                });
            }
        });

        // если выбраны не рубли - не выводим комбобокс
        dom.betSumInput.on('click', function (e) {
            if (betSumCombobox) {
                if (currency !== 'RUB') {
                    betSumCombobox.preventOpening(true);
                } else {
                    betSumCombobox.preventOpening(false);
                }
            }
        });

        dom.betSumInput.on('mouseenter', function () {
            var elem = $(this);

            if (currency !== 'RUB') {
                updateBonusTooltip();
            } else if (elem.attr('bb-tool')) {
                elem.removeAttr('bb-tool');
            }
        });

        dom.bonusExpressInput.on('change', function () {
            var isEnabled = $(this).prop('checked');

            if (isEnabled) {
                bonusExpress.enable();
            } else {
                bonusExpress.disable();
            }
        });

        $(document).on('change', '[name="cart-item-freebet-radio"]', function () {
            var checkedId = parseInt($(this).val());

            for (var i in items) {
                if (parseInt(items[i].originalId) !== checkedId) {
                    items[i].isSelectedForFreebet = false;
                } else {
                    items[i].isSelectedForFreebet = true;
                }
            }

            BettingCart.calc();
            BettingCart.validate();
            Freebet.validate();
        });
    };

    function setBetSumMaxMoneyValueButtonIsDisabled(isDisabled, message) {
        if (isDisabled === true) {
            dom.maxBetSumMoneyValueBtn.addClass('m-disabled');
            dom.maxBetSumMoneyValueBtn.addClass('m-disabled').attr('bb-tool', message);
        } else {
            dom.maxBetSumMoneyValueBtn.removeClass('m-disabled');
            dom.maxBetSumMoneyValueBtn.removeAttr('bb-tool');
        }
    }

    function loadBetSumMaxMoneyValue() {
        if (quantity() > 0) {
            var coefs = [];

            for (key in items) {
                coefs.push({
                    coefid: key,
                    eventid: items[key].eventId
                });
            }

            Ajax.postJson("/BettingCart/GetTotalMaxMoneyValue", {
                data: {
                    coefs: coefs,
                    currency: StandardCart.getCurrency()
                },
                success: function (resp) {
                    betSum = resp;
                    dom.betSumInput.val(app.numberToString(betSum));
                    BettingCart.calc();
                    BettingCart.validate();
                }
            });
        }
    }

    //For Express&System
    function replaceEventNumbersInCartError() {
        function getEventTitle(id) {
            for (key in items) {
                if (items[key].eventId == id)
                    return items[key].eventTitle;
            }
            return null;
        }

        var errorNode = dom.errorsIcon;
        if (!errorNode.length)
            return false;
        var errorText = errorNode.attr('bb-tool');
        if (errorText.length < 1)
            return false;
        var regExpRes = errorText.match(/№\d*/g);
        if (regExpRes === null)
            return;
        var ids = Array.from(regExpRes);
        [].forEach.call(ids, function (elem, i) {
            var id = elem.replace('№', ''),
                title = getEventTitle(id);
            if (title === null)
                return;
            errorText = errorText.replace(elem, title);
        });
        errorText = errorText.replace(/\n/g, '<br/><br/>');
        errorNode.attr('bb-tool', errorText);
    }

    //For Single
    function removeEventNumbersInCartErrors() {
        for (key in items) {
            var text = items[key].dom.errorsIcon.attr('bb-tool');
            if (text === undefined || text.length < 1)
                return false;
            var regExpRes = text.match(/: .+ событие №\d*/g);
            if (regExpRes === null)
                regExpRes = text.match(/ №\d*/g);

            if (regExpRes === null)
                return true;

            var ids = Array.from(regExpRes);
            [].forEach.call(ids, function (elem, i) {
                text = text.replace(elem, '');
            });
            text = text.replace(/\n/g, '<br/><br/>');
            items[key].dom.errorsIcon.attr('bb-tool', text);
        }
    }

    var hasSelectedLiveItems = function () {
        return Object.values(getItems()).some(function (item) {
            return item.isSelected && item.isLive;
        });
    }

    var canProposeFreeBet = function () {
        if (Freebet.isSelected() && Freebet.isActive())
            return false;

        if (Freebet.getAvaliableCount() == 0)
            return false;

        var onlySelectedQuantity = quantity(true);
        if (onlySelectedQuantity === 0)
            return false;

        if (isTypeSingle() && onlySelectedQuantity > 1)
            return false;

        if (hasSelectedLiveItems())
            return false;

        return true;
    }

    var prepareData = function (data) {
        var items = {};

        if (Freebet.isSelected() && isTypeSingle()) {
            var selectedItemForFreebet = getSelectedItemForFreebet();
            if (selectedItemForFreebet) {
                items[selectedItemForFreebet.originalId] = selectedItemForFreebet;
            }
        }
        else {
            items = getItems();
        }

        if (data.type === 'System')
            data.bettingCartInfo.NotWinEventCount = getNotWinEventsCount();

        data.bettingCartInfo.TotalMoneyValue = getBetSum();
        data.bettingCartInfo.TotalMoneyCurrency = getCurrency();

        data.bonusType = bonusExpress.isEnabled ? 'bonusExpress' : 'normal';

        for (key in items) {
            if (items[key].isSelected) {
                data.bettingCartPositions.push({
                    'Coef': {
                        coefid: items[key].actualId,
                        eventid: items[key].eventId
                    },
                    'OriginalValue': items[key].originalCoefValue,
                    'MoneyValue': items[key].bet,
                    'SubMode': items[key].mode,
                    'Currency': items[key].currency,
                    'IsLive': !!items[key].isLive
                });
            }
        }

        return data;
    };

    function hashCode(obj) {
        var hc = 0;
        var chars = JSON.stringify(obj).replace(/\{|\"|\}|\:|,/g, '');
        var len = chars.length;
        for (var i = 0; i < len; i++) {
            // Bump 7 to larger prime number to increase uniqueness
            hc += (chars.charCodeAt(i) * 7);
        }
        return hc;
    }

    var lastCheckedHashCode = 0;
    var validateTimerHandle;
    var sendValidate = function (data) {
        if (BettingCart.isSending == true)
            return;

        if (Object.keys(BettingCart.getItems()).length == 0)
            return;

        Ajax.postJson("/BettingCart/ValidateBettingCart", {
            data: {
                cartData: data
            },
            success: function (resp) {
                if (resp.IsSuccess) {
                    setSendButtonState(true);
                    return;
                }

                setSendButtonState(false);
                if (resp.CommonErrorMessage) {
                    showErrors([resp.CommonErrorMessage]);
                    StandardCart.humanizeErors.general();
                }
            }
        });
    }

    var serverValidate = function () {

        return true;

        if (Freebet.isActive() && Freebet.isSelected()) {
            return true;
        }

        if (BettingCart.isSendAllowed === false || window.globalAppSettings.currentUser.isAnonymous === true) {
            return false;
        }

        var data = {
            type: getType(),
            bettingCartInfo: {
                TotalMoneyValue: 0,
                TotalMoneyCurrency: window.globalAppSettings.currentUser.defaultBalance.currencyCode,
                NotWinEventCount: 0,
            },
            bettingCartPositions: [],
        };

        data = prepareData(data);
        if (data.bettingCartPositions.length == 0) return false;

        var hashcode = hashCode(data);
        if (lastCheckedHashCode === hashcode) return true;
        lastCheckedHashCode = hashcode;

        if (validateTimerHandle) {
            clearTimeout(validateTimerHandle);
        }
        validateTimerHandle = setTimeout(function () { sendValidate(data); }, 500);
        return true;
    }

    return {
        addItem: addItem,
        bonusExpress: bonusExpress,
        getBetSum: getBetSum,
        setBetSum: setBetSum,
        getNotWinEventsCount: getNotWinEventsCount,
        getBetDeletionMode: getBetDeletionMode,
        getActiveCoefMode: getActiveCoefMode,
        getData: getData,
        getCurrency: getCurrency,
        getItem: getItem,
        hasItem: hasItem,
        hideSuccessMessage: hideSuccessMessage,
        getItems: getItems,
        getCoefs: getCoefs,
        getSelectedItemForFreebet: getSelectedItemForFreebet,
        getSingleSelectedItemForFreebetProposal: getSingleSelectedItemForFreebetProposal,
        getType: getType,
        setType: setType,
        isTypeSingle: isTypeSingle,
        load: load,
        removeItem: removeItem,
        removeItemWithoutValidation: removeItemWithoutValidation,
        removeItemAfterSend: removeItemAfterSend,
        removeAllItems: removeAllItems,
        removeAllItemsAfterSend: removeAllItemsAfterSend,
        showErrors: showErrors,
        showSuccessMessage: showSuccessMessage,
        updateCalcResults: updateCalcResults,
        updateState: updateState,
        validate: validate,
        serverValidate: serverValidate,
        quantity: quantity,
        hasSelectedLiveItems: hasSelectedLiveItems,
        canProposeFreeBet: canProposeFreeBet,
        humanizeErors: {
            general: replaceEventNumbersInCartError,
            items: removeEventNumbersInCartErrors
        },
        addTestItem: function () {
            this.addItem({
                oId: Math.floor(Math.random() * 10000) + 1,
                aId: Math.floor(Math.random() * 10000) + 1,
                eId: Math.floor(Math.random() * 10000) + 1,
                eTitle: Localization.getString('BettingCart.TestEvent', 'Тестовое событие'),
                rTitle: Localization.getString('BettingCart.TestResult', 'Тестовый исход'),
                val: '2.05',
                originalCoefValue: '2.05',
                isLive: false,
            });
        },
        prepareData: prepareData
    }
}());